/**
 * zip 包命名契约。GENERATED 区块由后端 Registry 生成。
 * 重新生成: mvn -pl wallpaper-app exec:java -Dexec.mainClass=com.kikatech.wallpaper.genericresource.zip.GenericResourceZipPackageSpecGenerator
 */

// ===== GENERATED FROM Registry — 勿手改此区块 =====
/** @type {Record<string, { includes?: string[], exact?: string[], pattern?: string[], optional?: string[], examples?: string[], anyOf?: boolean, minFiles?: number, maxFiles?: number }>} */
export const ZIP_PACKAGE_SPECS = {
  'Filter': {
    includes: ['滤镜主图', '预览图'],
    exact: ['filter.png'],
    pattern: ['preview.*'],
    optional: ['preview.*'],
    examples: ['filter.png + preview.jpg'],
  },
  'Clothing': {
    includes: ['服装主图', '预览图'],
    exact: ['clothing.png'],
    pattern: ['preview.*'],
    optional: ['preview.*'],
    examples: ['clothing.png + preview.jpg'],
  },
  'Template': {
    includes: ['预览图'],
    pattern: ['preview.*'],
    examples: ['preview.png'],
  },
  'Flow': {
    includes: ['预览图 preview0', '预览图 preview1', '配置文件'],
    pattern: ['preview0*', 'preview1*', 'config*'],
    examples: ['preview0.png + preview1.png + config.json'],
  },
  'recipe(食谱)': {
    includes: ['预览图', '封面图', '食谱正文'],
    exact: ['content.md'],
    pattern: ['preview.*', 'cover.*'],
    examples: ['preview.jpg + cover.png + content.md'],
  },
  'puzzle(拼图)': {
    includes: ['拼图主图', '预览图'],
    pattern: ['image.*', 'preview.*'],
    examples: ['image.png + preview.jpg'],
  },
  'level(关卡)': {
    includes: ['关卡图片 image1', '关卡图片 image2', '配置文件'],
    exact: ['config.json'],
    pattern: ['image1.*', 'image2.*'],
    examples: ['image1.png + image2.png + config.json'],
  },
  'recipe_v2': {
    includes: ['菜品预览图', '食谱 JSON 配置'],
    pattern: ['*.json', '_preview.jpg'],
    examples: ['dish_preview.jpg + recipe.json'],
  },
  'workout_action': {
    includes: ['动作演示视频（主视角）', '动作演示视频（侧视角）（可选）', '封面图', '运营 JSON 配置（可选）', '动作切换口令（可选）', '动作执行引导（可选）'],
    pattern: ['*_action.mp4', '*_side_action.mp4', '*_cover.*', '*_config.json', '*_switch_voice.mp3', '*_guide_voice.mp3'],
    optional: ['*_side_action.mp4', '*_config.json', '*_switch_voice.mp3', '*_guide_voice.mp3'],
    examples: ['squat_action.mp4 + squat_side_action.mp4 + squat_cover.jpg + squat_config.json + squat_switch_voice.mp3 + squat_guide_voice.mp3'],
  },
  'workout_music': {
    includes: ['背景音乐音频', '运营 JSON 配置（可选）'],
    pattern: ['*_music.mp3', '*_config.json'],
    optional: ['*_config.json'],
    examples: ['morning_music.mp3 + morning_config.json'],
  },
  'workout_voice': {
    includes: ['节点语音（start/rest/complete 必传）', '运营 JSON 配置（可选）'],
    pattern: ['start_voice.mp3', 'rest_voice.mp3', 'complete_voice.mp3', 'next_voice.mp3', 'keep_going_voice.mp3', 'halfway_voice.mp3', '*_config.json'],
    optional: ['next_voice.mp3', 'keep_going_voice.mp3', 'halfway_voice.mp3', '*_config.json'],
    examples: ['start_voice.mp3 + rest_voice.mp3 + complete_voice.mp3 + coach_config.json'],
  },
  'workout_collection': {
    includes: ['合集封面图（女）', '合集封面图（男）', '运营 JSON 配置（可选）'],
    pattern: ['*_cover_female.*', '*_cover_male.*', '*_config.json'],
    optional: ['*_config.json'],
    examples: ['hiit_cover_female.jpg + hiit_cover_male.jpg + hiit_config.json'],
  },
  'badge': {
    includes: ['未解锁', '解锁后', '动效'],
    pattern: ['*_locked.*', '*_unlocked.*', '*_animation.*'],
    examples: ['walking_star_locked.png + walking_star_unlocked.png + walking_star_animation.gif'],
  },
  'article': {
    includes: ['封面图', '元素图', 'Md 正文'],
    exact: ['content.md'],
    pattern: ['*_background.*', '*_element.*'],
    examples: ['story_background.jpg + story_element.png + content.md'],
  },
  'stickers': {
    includes: ['每一张能转的图都会变成贴纸，json 不会当成贴纸'],
    pattern: ['*.png', '*.jpg', '*.jpeg', '*.webp', '*.gif', '*.json'],
    optional: ['*.json'],
    examples: ['01_smile.png + 02_lol.png'],
    anyOf: true,
    minFiles: 1,
    maxFiles: 30,
  },
}

/** 须上传 .zip 的资源类型（与 Registry zipRequired 一致） */
export const ZIP_ONLY_TYPES = [
  'Filter',
  'Clothing',
  'Template',
  'Flow',
  'recipe(食谱)',
  'puzzle(拼图)',
  'level(关卡)',
  'recipe_v2',
  'workout_action',
  'workout_music',
  'workout_voice',
  'workout_collection',
  'badge',
  'article',
  'stickers',
]
// ===== END GENERATED =====

/** 每次返回独立数组，避免浅拷贝共享 EMPTY 常量被调用方污染 */
function createEmptyZipPackageSpec() {
  return {
    includes: [],
    required: [],
    exact: [],
    pattern: [],
    optional: [],
    examples: [],
    anyOf: false,
    minFiles: null,
    maxFiles: null,
  }
}

export function resolveZipPackageSpec(assetType) {
  const type = String(assetType || '').trim()
  if (!type) {
    return createEmptyZipPackageSpec()
  }
  const spec = ZIP_PACKAGE_SPECS[type]
  if (!spec) {
    return createEmptyZipPackageSpec()
  }
  return {
    includes: [...(spec.includes || [])],
    required: [...(spec.required || [])],
    exact: [...(spec.exact || [])],
    pattern: [...(spec.pattern || [])],
    optional: [...(spec.optional || [])],
    examples: [...(spec.examples || [])],
    anyOf: spec.anyOf === true,
    minFiles: Number.isInteger(spec.minFiles) ? spec.minFiles : null,
    maxFiles: Number.isInteger(spec.maxFiles) ? spec.maxFiles : null,
  }
}

/** 命名要求展示顺序：优先 spec.required；否则 pattern+exact 去掉 optional */
export function resolveRequiredPatterns(spec) {
  if (!spec) {
    return []
  }
  if (spec.required && spec.required.length) {
    return [...spec.required]
  }
  const pattern = spec.pattern || []
  const exact = spec.exact || []
  const optional = new Set(spec.optional || [])
  const all = [...pattern, ...exact]
  return all.filter((item) => !optional.has(item))
}

export function hasZipPackageSpec(assetType) {
  const spec = resolveZipPackageSpec(assetType)
  return spec.exact.length > 0 || spec.pattern.length > 0 || spec.examples.length > 0
}

export function summarizeZipPackageSpec(assetType) {
  const type = String(assetType || '').trim()
  const spec = resolveZipPackageSpec(type)
  const parts = resolveRequiredPatterns(spec)
  if (!parts.length) {
    return ''
  }
  return spec.anyOf ? parts.join(' 或 ') : parts.join('、')
}

export function isZipOnlyAssetType(assetType) {
  return ZIP_ONLY_TYPES.includes(String(assetType || ''))
}
